import React from "react";
import { Button, Divider } from "@mui/material";
import { styled } from "@mui/system";

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "variant",
})(({ variant = "default" }) => ({
  [`&.MuiButton-root`]: {
    padding: "0px 25px",
  },
  color: variant === "danger" ? "var(--secondary-1)" : "var(--primary-main)",
  backgroundColor: "transparent",
  "&:hover": {
    fontWeight:
      variant == "danger" ? "var(--font-bold)" : "var(--font-semi-bold)",
    backgroundColor: "transparent",
  },
  whiteSpace: "nowrap",
}));

const ShepHorizontalMenu = ({ actions }) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {actions.map((action, index) => {
        return (
          <div
            key={index}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {index > 0 && <Divider orientation="vertical" flexItem />}
            <StyledButton onClick={action.onClick} variant={action.variant} disabled={action.disabled}>
              {action.label}
            </StyledButton>
          </div>
        );
      })}
    </div>
  );
};

export default ShepHorizontalMenu;
